/**
 * Idempotency-Key generation for mutating calls (docs/API.md: "All mutating endpoints accept an
 * Idempotency-Key header"; MASTER_PROMPT.md hard rule #6). `crypto.randomUUID` is available in
 * all modern browsers, Cloudflare Workers and Node >= 19; the fallback below only matters for an
 * older embedding context (e.g. a third-party site running the widget in a legacy WebView).
 */
export function generateIdempotencyKey(): string {
  const cryptoObj = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}
